import { render } from "./PaymentTypeSelector.vue?vue&type=template&id=6b8c710c"
import script from "./PaymentTypeSelector.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/PaymentTypeSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b8c710c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b8c710c', __exports__)) {
    api.reload('6b8c710c', __exports__)
  }
  
  module.hot.accept("./PaymentTypeSelector.vue?vue&type=template&id=6b8c710c", () => {
    api.rerender('6b8c710c', render)
  })

}


export default __exports__